import { Box, Fade, Paper } from '@material-ui/core';

import { ChartDataPoint } from '@vyce/core/src/types';
import { PieChart } from '@vyce/core/src/modules/widgetsModule/components/PieChart';

import { FormSummaryQuestionTitle } from './FormSummaryQuestionTitle';

export const FormSummaryPieChart = ({
  data,
  title,
  totalAnswers,
  description,
  videoLink,
  photoUrl,
  explanation,
  pdfUrl,
  onItemClick,
}: {
  data: ChartDataPoint[];
  title: string;
  totalAnswers: number;
  description?: string;
  videoLink?: string;
  photoUrl?: string;
  explanation?: string;
  pdfUrl?: string;
  onItemClick?: (answerValue: string, answerLabel: string) => void;
}) => {
  const handleChartClick = onItemClick
    ? (datum: { id: string | number }) => {
        const point = data.find(item => item.label === datum.id);
        if (point) onItemClick(point.value, point.label);
      }
    : undefined;

  return (
    <Fade in={true} timeout={200} style={{ width: '100%' }}>
      <Paper variant="outlined" style={{ padding: 24, width: '100%', height: '100%' }}>
        <FormSummaryQuestionTitle
          title={title}
          totalAnswers={totalAnswers}
          description={description}
          videoLink={videoLink}
          photoUrl={photoUrl}
          explanation={explanation}
          pdfUrl={pdfUrl}
        />

        {data.length > 0 && (
          <Box minHeight={350} display="grid">
            <PieChart
              data={data.map(item => ({
                id: item.label,
                label: item.label,
                value: item.count,
                percent: item.value.toString(),
              }))}
              handleChartClick={handleChartClick}
            />
          </Box>
        )}
      </Paper>
    </Fade>
  );
};
